import { useQuery } from '@tanstack/react-query';
import { schoolsApi } from '../../domains/schools/api/schools.api';

/**
 * Fetches counties list from backend.
 * Counties are static reference data, cached for 24 hours.
 */
export function useCounties() {
    return useQuery({
        queryKey: ['counties'],
        queryFn: () => schoolsApi.getCounties(),
        staleTime: 24 * 60 * 60 * 1000, // 24 hours (counties never change)
        gcTime: 7 * 24 * 60 * 60 * 1000, // 7 days
        retry: 2,
    });
}
